/**
 * metaタグを設定するutil
 */

import Constants from '../constants';
 
const SetMeta = {
    setMeta(Vue, doc, title, description, ogImagePath = Constants.DEFAULT_OG_IMG_PATH, isTopPage = false) {
        doc.title = title;
        doc.querySelector("meta[property='og:title']").setAttribute('content', title);

        doc.querySelector("meta[name='description']").setAttribute('content', description);
        doc.querySelector("meta[property='og:description']").setAttribute('content', description);
        
        doc.querySelector("meta[property='og:url']").setAttribute('content', doc.location.href);
        doc.querySelector("meta[property='og:type']").setAttribute('content', isTopPage ? 'website' : 'article');
        doc.querySelector("meta[property='og:site_name']").setAttribute('content', Vue.$t('message.bandName'));
        doc.querySelector("meta[property='og:locale']").setAttribute(
            'content', Vue.$i18n.locale === Constants.LOCALE.EN ? 'en_US' : 'ja_JP');
        doc.querySelector("meta[http-equiv='content-language']").setAttribute(
            'content', Vue.$i18n.locale === Constants.LOCALE.EN ? 'en' : 'ja');

        // ogImg
        const ogPath = `https://kyousou-gakudan.com/ogImg${ogImagePath}.png`;
        doc.querySelector("meta[property='og:image']").setAttribute('content', ogPath);
        doc.querySelector("meta[name='twitter:image']").setAttribute('content', ogPath);

        // tw
        doc.querySelector("meta[name='twitter:title']").setAttribute('content', title);
        doc.querySelector("meta[name='twitter:description']").setAttribute('content', description);
    },
};

export default SetMeta;